import { State } from "./State";
import { IOverlayData, OverlayType } from "../server/data/ISpinData";
import SpinModel from "../model/SpinModel";
import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";
import ReelGroup from "../views/ReelGroup";

export default class LockSymbolState extends State {
    public enter(): void {
        super.enter();
        let overlays: IOverlayData[] = [];
        const scene = ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene();
        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        if (SpinModel.hasOverlay(OverlayType.Locked)) {
            overlays.push(...SpinModel.getOverlays(OverlayType.Locked))
        }
        // Check and replace if has fake ids
        overlays.forEach((overlay, overlayIndex) => {
            overlay.symbolPosition.forEach((reel, reelIndex) => {
                reel.forEach((sym, symIndex) => {
                    if (sym) {
                        let symFakeId = reelGroup.getSymbolAt(reelIndex, symIndex)?.fakeId;
                        const symbolAnim = reelGroup.winSymbolsView.getSymbolAnim(reelIndex, symIndex);
                        if (symFakeId || symbolAnim) {
                            if (symbolAnim?.isLocked) {
                                symFakeId = symbolAnim.spine?.id;
                            }

                            if (symFakeId) {
                                overlays[overlayIndex].symbolPosition[reelIndex][symIndex] = symFakeId;
                            }
                        }
                    }
                })
            })
        })
        // REMOVED THIS BEACAUSE MERGING BOTH OVERLAYS SHOULD BE CUSTOM LOGIC
        // if (SpinModel.hasOverlay(OverlayType.Walking)) {
        //     overlays.push(...SpinModel.getOverlays(OverlayType.Walking))
        // }

        if (overlays.length) {

            let count = overlays.length;
            overlays.forEach(overlay => {
                reelGroup.winSymbolsView.lockSymbols(overlay).then(() => {
                    count--;
                    if (count <= 0) {
                        this.exit();
                    }
                });

            });
        } else {
            this.exit();
        }
    }

}
